import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function ClaimsAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <path
        fill="#fff"
        d="M114.53,41.14c0-1.42-.04-2.85-.1-4.32-.06-1.29-1.12-2.18-2.31-2.2-.63-.01-1.25-.04-1.86-.08-1.9-.12-3.77-.36-5.59-.74-.11-.02-.22-.04-.33-.07-.07-.02-.15-.04-.22-.05-4.11-.96-7.88-2.72-11.37-5.6-.55-.45-1.15-.62-1.74-.58-.59-.04-1.2.13-1.74.58-3.48,2.88-7.26,4.64-11.37,5.6-.07.02-.15.04-.22.05-.11.02-.22.05-.33.07-1.83.38-3.7.61-5.59.74-.62.04-1.23.06-1.86.08-1.19.02-2.25.91-2.31,2.2-.06,1.47-.1,2.9-.1,4.32,0,.09,0,.17,0,.26,0,4.78.43,9.35,1.69,14.23,3.05,11.8,10.14,20.39,20.47,26.62.32.19.83.22,1.37.15.55.07,1.05.05,1.37-.15,10.33-6.23,17.42-14.82,20.47-26.62,1.26-4.88,1.68-9.45,1.69-14.23,0-.09,0-.17,0-.26ZM98.66,63.86c-1.37,1.56-3.11,2.27-4.77,2.73l-.05,4.41-5.54.11-.05-4.41c-2.58-.39-4.64-1.45-6.3-3.25l-.63-.68,2.58-5.06,1.28,1.13c2.35,2.07,6.35,2.78,8.08,1.43.35-.28.59-.68.62-1.06.02-.26-.06-.48-.25-.67-.5-.52-1.9-.89-3.26-1.24-3.17-.83-7.95-2.08-7.85-7.55.05-2.81,1.54-5.02,4.07-6.07l1.52-.63c0-1.03.06-1.89.19-3l.14-1.13,1.14-.03c1.08-.03,1.78-.03,3.03.08l1.2.1.05,3.93c1.91.43,3.55,1.22,4.89,2.35l.76.64-1.28,2.91c-.12.27-.4.7-.6.92-.67.72-1.82.54-2.39.19-1.83-1.12-4.98-2.18-6.16-.52-.13.18-.18.39-.14.59.03.14.11.33.34.48.68.45,1.66.7,2.8.99,1.59.41,3.57.93,5.48,2.23,1.55,1.06,2.54,2.68,2.78,4.58.25,1.99-.37,4.01-1.7,5.53Z"
      />
      <g>
        <path
          fill="#fff"
          d="M118.72,89.05l-20.8,15.88c-3.58,2.73-7.02,5.24-10.95,7.34-2.48,1.33-5.5,1.29-8.04.12l-11.81-5.42c-.81-.37-2.73-.53-3.52-.16l-6.41,2.97-11.18-18.74,14.57-8.6,27.13,7.95c1.99,1.07,2.63,3.21,1.87,5.29-.69,1.88-2.88,3.06-5.12,2.37l-11.46-3.48c-.49-.15-1.53.38-1.77.72-.27.4.29,1.51.79,1.66l10.72,3.26c2.25.69,4.34.94,6.5-.39,1.72-1.05,3.2-2.87,3.3-5.5l23.13-10.07c1.24-.54,3.15-.15,3.67.65.79,1.21.79,3.06-.62,4.14Z"
        />
        <rect
          fill="#fff"
          x="37.2"
          y="89.92"
          width="13.52"
          height="31.33"
          transform="translate(-47.94 37.51) rotate(-30.87)"
        />
      </g>
    </svg>
  );
}
